<template>
  <div class="main">
    <div class="ibox-content icons-box">
      <div>
        <div class="select-tree">
          <el-scrollbar tag="div" class="is-empty" wrap-class="el-select-dropdown__wrap" view-class="el-select-dropdown__list">
            <div class="icons-wrapper">
              <svg-icon v-for="icon in iconList" :key="icon" :icon-class="icon" @click="selectIcon(icon)" />
            </div>
          </el-scrollbar>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'index',
  data() {
    return {
      iconList: [
        'menu_home',
        'menu_entrust',
        'menu_takeSamples',
        'menu_internalTransfer',
        'menu_taskAllocation',
        'menu_waitExperiment',
        'menu_audit',
        'menu_experimentReport',
        'menu_testingStatistics',
        'menu_device',
        'menu_customer',
        'menu_invoice',
        'menu_thirdParty',
        'menu_system',
        'menu_account',
        'menu_archives',
        'menu_invoice',
        'menu_experiment_statistics',
        'menu_projectQuality',
        'menu_salary',
        'menu_meterial',
        'menu_materialManage',
        'menu_humanResources',
        'menu_expense',
        'menu_dataStatistics',
        'menu_contract',
        'menu_attendance',
        'menu_car'
      ]
    };
  },
  mounted() {},
  methods: {
    selectIcon(iconName) {
      this.$emit('chooseIcon', iconName);
    }
  }
};
</script>

<style type="text/css" scoped>
.select-tree .icons-wrapper {
  display: block;
}
.select-tree .is-empty .svg-icon {
  width: 50px;
  height: 50px;
  line-height: 50px;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  font-size: 24px;
  padding: 10px;
  color: #000000;
}
.select-tree .is-empty .svg-icon:hover {
  background-color: #009688;
  color: #ffffff;
}

.bs-glyphicons-list {
  padding-left: 0;
  list-style: none;
}
.bs-glyphicons li {
  float: left;
  width: 20%;
  padding: 10px;
  font-size: 10px;
  line-height: 1.4;
  text-align: center;
  background-color: #f9f9f9;
  border: 1px solid #fff;
  cursor: pointer;
}
.bs-glyphicons .glyphicon,
.bs-glyphicons .fa {
  margin-top: 5px;
  margin-bottom: 10px;
  font-size: 24px;
}
.bs-glyphicons .glyphicon-class {
  display: block;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.bs-glyphicons li:hover {
  color: #fff;
  background-color: #563d7c;
}
</style>
